import AgVtDatePicker from '@/components/common/AgVtDatePicker'

export default {
    agDateInput: AgVtDatePicker
}
